module.exports = __webpack_public_path__ + "img/xml.cc57968.svg";